import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=3b56a15e&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=ts&"
export * from "./Form.vue?vue&type=script&lang=ts&"
import style0 from "./Form.vue?vue&type=style&index=0&id=3b56a15e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b56a15e",
  null
  
)

export default component.exports